// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Table,
//   Button,
//   Form,
//   Modal,
//   InputGroup,
//   Pagination,
//   Badge,
//   Spinner,
// } from "react-bootstrap";
// import api from "../../api";
// import Can from "../../components/Can";
// import { usePermissions } from "../../context/PermissionContext";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./TaskWorkflowManagementPage.css";

// const SCOPE_TYPES = ["GLOBAL", "TASK_TYPE", "DEPARTMENT", "PROJECT", "PROJECT_MODULE", "TASK"];

// const initialForm = {
//   name: "",
//   code: "",
//   description: "",
//   scope_type: "GLOBAL",
//   scope_id: "",
//   task_type_id: "",
//   priority_order: "",
//   is_default: false,
// };

// export default function TaskWorkflowManagementPage() {
//   const navigate = useNavigate();
//   const { can } = usePermissions();

//   const [workflows, setWorkflows] = useState([]);
//   const [total, setTotal] = useState(0);

//   const [taskTypes, setTaskTypes] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [projectModules, setProjectModules] = useState([]);
//   const [loadingScopeTargets, setLoadingScopeTargets] = useState(false);

//   const [search, setSearch] = useState("");
//   const [scopeTypeFilter, setScopeTypeFilter] = useState("");
//   const [statusFilter, setStatusFilter] = useState("");

//   const [sortField, setSortField] = useState("priority_order");
//   const [sortOrder, setSortOrder] = useState("asc");

//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(20);

//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);

//   const [form, setForm] = useState(initialForm);
//   const [editId, setEditId] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   const [deleteTarget, setDeleteTarget] = useState(null);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);

//   useEffect(() => {
//     fetchWorkflows();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [search, scopeTypeFilter, statusFilter, sortField, sortOrder, currentPage, pageSize]);

//   useEffect(() => {
//     fetchScopeReferenceData();
//   }, []);

//   const fetchScopeReferenceData = async () => {
//     try {
//       const [typeRes, deptRes, projectRes] = await Promise.all([
//         api.get("/task-types", { params: { is_active: 1, pageSize: 200 } }),
//         api.get("/departments", { params: { is_active: 1, pageSize: 200 } }),
//         api.get("/projects", { params: { is_active: 1, pageSize: 200 } }),
//       ]);
//       setTaskTypes(Array.isArray(typeRes.data?.data) ? typeRes.data.data : []);
//       setDepartments(Array.isArray(deptRes.data?.data) ? deptRes.data.data : []);
//       setProjects(Array.isArray(projectRes.data?.data) ? projectRes.data.data : []);
//     } catch (err) {
//       console.error("Fetch workflow scope reference data error:", err);
//     }
//   };

//   const fetchProjectModules = async (projectId) => {
//     if (!projectId) {
//       setProjectModules([]);
//       return;
//     }
//     try {
//       setLoadingScopeTargets(true);
//       const res = await api.get(`/projects/${projectId}/modules`, { params: { is_active: 1, pageSize: 200 } });
//       setProjectModules(Array.isArray(res.data?.data) ? res.data.data : []);
//     } catch (err) {
//       console.error("Fetch project modules error:", err);
//       setProjectModules([]);
//     } finally {
//       setLoadingScopeTargets(false);
//     }
//   };

//   const fetchWorkflows = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get("/task-workflows", {
//         params: {
//           search: search || undefined,
//           scope_type: scopeTypeFilter || undefined,
//           is_active: statusFilter === "" ? undefined : statusFilter,
//           sortField,
//           sortOrder,
//           page: currentPage,
//           pageSize,
//         },
//       });
//       setWorkflows(Array.isArray(res.data?.data) ? res.data.data : []);
//       setTotal(res.data?.meta?.total || 0);
//     } catch (err) {
//       console.error("Fetch task workflows error:", err);
//       toast.error(err.response?.data?.message || "Failed to fetch workflows");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const totalPages = Math.max(Math.ceil(total / pageSize), 1);

//   const handleSort = (field) => {
//     if (sortField === field) {
//       setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
//     } else {
//       setSortField(field);
//       setSortOrder("asc");
//     }
//   };

//   const sortIcon = (field) => (sortField !== field ? "↕" : sortOrder === "asc" ? "↑" : "↓");

//   const handleChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

//   const handleScopeTypeChange = (scopeType) => {
//     setForm((prev) => ({ ...prev, scope_type: scopeType, scope_id: "", task_type_id: scopeType === "TASK_TYPE" ? prev.task_type_id : "" }));
//     if (scopeType === "PROJECT_MODULE") setProjectModules([]);
//   };

//   const openAdd = () => {
//     setForm(initialForm);
//     setEditId(null);
//     setShowModal(true);
//   };

//   const openEdit = (workflow) => {
//     setForm({
//       name: workflow.name || "",
//       code: workflow.code || "",
//       description: workflow.description || "",
//       scope_type: workflow.scope_type || "GLOBAL",
//       scope_id: workflow.scope_id ?? "",
//       task_type_id: workflow.task_type_id ?? "",
//       priority_order: workflow.priority_order ?? "",
//       is_default: !!workflow.is_default,
//     });
//     setEditId(workflow.id);
//     if (workflow.scope_type === "PROJECT_MODULE" && workflow.scope_id) {
//       // scope_id for PROJECT_MODULE is a module id — we don't know its parent
//       // project here, so the module dropdown is left for the admin to
//       // re-select if they want to change it; the current value still displays.
//     }
//     setShowModal(true);
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     setEditId(null);
//     setForm(initialForm);
//   };

//   const handleSave = async () => {
//     if (!form.name.trim()) {
//       toast.warning("Workflow name is required");
//       return;
//     }
//     if (form.scope_type !== "GLOBAL" && !form.scope_id) {
//       toast.warning("Please select a scope target for this scope type");
//       return;
//     }

//     const payload = {
//       name: form.name.trim(),
//       description: form.description.trim() || null,
//       scope_type: form.scope_type,
//       scope_id: form.scope_type === "GLOBAL" ? null : Number(form.scope_id),
//       task_type_id: form.scope_type === "TASK_TYPE" ? null : (form.task_type_id ? Number(form.task_type_id) : null),
//       priority_order: form.priority_order === "" ? 0 : Number(form.priority_order),
//       is_default: form.is_default,
//     };

//     if (!editId) {
//       payload.code = form.code.trim() || undefined;
//     }

//     try {
//       setSaving(true);
//       if (editId) {
//         await api.put(`/task-workflows/${editId}`, payload);
//         toast.success("Workflow updated");
//       } else {
//         await api.post("/task-workflows", payload);
//         toast.success("Workflow created");
//       }
//       closeModal();
//       fetchWorkflows();
//     } catch (err) {
//       console.error("Save workflow error:", err);
//       const data = err.response?.data;
//       if (data?.code === "WORKFLOW_DEFAULT_CONFLICT") {
//         toast.error("An active default workflow already exists for this scope.");
//       } else {
//         toast.error(data?.message || "Failed to save workflow");
//       }
//     } finally {
//       setSaving(false);
//     }
//   };

//   const toggleStatus = async (workflow) => {
//     try {
//       await api.patch(`/task-workflows/${workflow.id}/status`, { is_active: !workflow.is_active });
//       toast.success(workflow.is_active ? "Workflow deactivated" : "Workflow activated");
//       fetchWorkflows();
//     } catch (err) {
//       console.error("Toggle workflow status error:", err);
//       const data = err.response?.data;
//       if (data?.code === "WORKFLOW_DEFAULT_CONFLICT") {
//         toast.error("An active default workflow already exists for this scope.");
//       } else {
//         toast.error(data?.message || "Failed to update status");
//       }
//     }
//   };

//   const openDeleteModal = (workflow) => {
//     setDeleteTarget(workflow);
//     setShowDeleteModal(true);
//   };

//   const closeDeleteModal = () => {
//     setDeleteTarget(null);
//     setShowDeleteModal(false);
//   };

//   const confirmDelete = async () => {
//     if (!deleteTarget) return;
//     try {
//       await api.delete(`/task-workflows/${deleteTarget.id}`);
//       toast.success("Workflow deleted");
//       closeDeleteModal();
//       fetchWorkflows();
//     } catch (err) {
//       console.error("Delete workflow error:", err);
//       const data = err.response?.data;
//       if (data?.code === "WORKFLOW_IN_USE") {
//         const d = data.details?.dependents;
//         toast.error(`Cannot delete: in use (tasks: ${d?.tasks ?? 0}, history: ${d?.history ?? 0}). Deactivate instead.`);
//       } else {
//         toast.error(data?.message || "Failed to delete workflow");
//       }
//       closeDeleteModal();
//     }
//   };

//   const scopeTargetLabel = (workflow) => {
//     if (workflow.scope_type === "GLOBAL") return "—";
//     if (workflow.scope_type === "TASK_TYPE") return workflow.task_type_name || `#${workflow.scope_id}`;
//     return `#${workflow.scope_id}`;
//   };

//   return (
//     <div className="unit-page workflow-mgmt-theme">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Configuration</div>
//           <h2>Task Workflow Management</h2>
//           <p>Configure which statuses and transitions apply to a task type, department, project or module.</p>
//         </div>

//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchWorkflows}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>

//           <Can moduleKey="task_workflows" actionKey="create">
//             <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
//               <i className="fa-solid fa-plus" aria-hidden="true"></i>
//               Add Workflow
//             </Button>
//           </Can>
//         </div>
//       </div>

//       <div className="unit-stats-row">
//         <div className="unit-stat-card">
//           <div className="workflow-stat-icon workflow-stat-icon-primary">
//             <i className="fa-solid fa-sitemap" aria-hidden="true"></i>
//           </div>
//           <div className="workflow-stat-text">
//             <span>Total Workflows</span>
//             <strong>{total}</strong>
//           </div>
//         </div>
//         <div className="unit-stat-card">
//           <div className="workflow-stat-icon workflow-stat-icon-success">
//             <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
//           </div>
//           <div className="workflow-stat-text">
//             <span>Current Page</span>
//             <strong>{currentPage}</strong>
//           </div>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div>
//             <h5>
//               <i className="fa-solid fa-code-branch workflow-list-icon" aria-hidden="true"></i>
//               Workflow List
//             </h5>
//             <p>Search, filter, add, update, activate/deactivate or delete workflows.</p>
//           </div>

//           <div className="unit-toolbar-actions" style={{ flexWrap: "wrap", gap: 8 }}>
//             <InputGroup className="unit-search" style={{ maxWidth: 240 }}>
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>
//               <Form.Control
//                 placeholder="Search name or code..."
//                 aria-label="Search workflow name or code"
//                 value={search}
//                 onChange={(e) => {
//                   setCurrentPage(1);
//                   setSearch(e.target.value);
//                 }}
//               />
//             </InputGroup>

//             <Form.Select
//               style={{ maxWidth: 170 }}
//               value={scopeTypeFilter}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setScopeTypeFilter(e.target.value);
//               }}
//             >
//               <option value="">All Scope Types</option>
//               {SCOPE_TYPES.map((s) => <option key={s} value={s}>{s}</option>)}
//             </Form.Select>

//             <Form.Select
//               style={{ maxWidth: 150 }}
//               value={statusFilter}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setStatusFilter(e.target.value);
//               }}
//             >
//               <option value="">All Statuses</option>
//               <option value="1">Active</option>
//               <option value="0">Inactive</option>
//             </Form.Select>

//             <Form.Select
//               className="unit-page-size"
//               style={{ maxWidth: 120 }}
//               value={pageSize}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setPageSize(Number(e.target.value));
//               }}
//             >
//               <option value={10}>10 rows</option>
//               <option value={20}>20 rows</option>
//               <option value={50}>50 rows</option>
//             </Form.Select>
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader">
//               <Spinner animation="border" />
//               <p>Loading workflows...</p>
//             </div>
//           ) : (
//             <Table responsive className="unit-table">
//               <thead>
//                 <tr>
//                   <th className="sortable" onClick={() => handleSort("name")}>Name {sortIcon("name")}</th>
//                   <th className="sortable" onClick={() => handleSort("code")}>Code {sortIcon("code")}</th>
//                   <th className="sortable" onClick={() => handleSort("scope_type")}>Scope {sortIcon("scope_type")}</th>
//                   <th>Target</th>
//                   <th>Default</th>
//                   <th className="sortable" onClick={() => handleSort("is_active")}>Status {sortIcon("is_active")}</th>
//                   <th className="text-end">Actions</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {workflows.length > 0 ? (
//                   workflows.map((workflow) => (
//                     <tr key={workflow.id}>
//                       <td><strong>{workflow.name}</strong></td>
//                       <td>{workflow.code}</td>
//                       <td><Badge bg="light" text="dark">{workflow.scope_type}</Badge></td>
//                       <td>{scopeTargetLabel(workflow)}</td>
//                       <td>{workflow.is_default ? <Badge bg="info">Default</Badge> : "—"}</td>
//                       <td>
//                         <Badge className="unit-status" bg={workflow.is_active ? "success" : "secondary"}>
//                           {workflow.is_active ? "Active" : "Inactive"}
//                         </Badge>
//                       </td>
//                       <td>
//                         <div className="unit-actions">
//                           <Button
//                             className="unit-icon-btn workflow-open-editor"
//                             title="Manage statuses & transitions"
//                             aria-label="Manage statuses & transitions"
//                             onClick={() => navigate(`/admin/task-workflows/${workflow.id}/editor`)}
//                           >
//                             <i className="fa-solid fa-diagram-project" aria-hidden="true"></i>
//                           </Button>

//                           <Can moduleKey="task_workflows" actionKey="edit">
//                             <Button
//                               className="unit-icon-btn unit-edit"
//                               title="Edit"
//                               aria-label={`Edit ${workflow.name || "workflow"}`}
//                               onClick={() => openEdit(workflow)}
//                             >
//                               <i className="fa-solid fa-pen" aria-hidden="true"></i>
//                             </Button>
//                           </Can>

//                           {(can("task_workflows", "activate") || can("task_workflows", "deactivate")) && (
//                             <Button
//                               className="unit-icon-btn workflow-toggle"
//                               title={workflow.is_active ? "Deactivate" : "Activate"}
//                               aria-label={workflow.is_active ? "Deactivate" : "Activate"}
//                               onClick={() => toggleStatus(workflow)}
//                             >
//                               <i className={`fa-solid ${workflow.is_active ? "fa-pause" : "fa-play"}`} aria-hidden="true"></i>
//                             </Button>
//                           )}

//                           <Can moduleKey="task_workflows" actionKey="delete">
//                             <Button
//                               className="unit-icon-btn unit-delete"
//                               title="Delete"
//                               aria-label={`Delete ${workflow.name || "workflow"}`}
//                               onClick={() => openDeleteModal(workflow)}
//                             >
//                               <i className="fa-solid fa-trash" aria-hidden="true"></i>
//                             </Button>
//                           </Can>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="7">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">
//                           <i className="fa-solid fa-sitemap" aria-hidden="true"></i>
//                         </div>
//                         <h5>No workflows found</h5>
//                         <p>Try another search or add a new workflow.</p>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">
//             Showing <strong>{workflows.length}</strong> of <strong>{total}</strong> workflows
//           </div>

//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
//               {[...Array(totalPages)].map((_, i) => (
//                 <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
//                   {i + 1}
//                 </Pagination.Item>
//               ))}
//               <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <Modal show={showModal} onHide={closeModal} centered className="unit-modal" size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>{editId ? "Edit Workflow" : "Add New Workflow"}</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <div className="row g-3">
//             <div className="col-md-6">
//               <Form.Label>Name</Form.Label>
//               <Form.Control
//                 placeholder="e.g. Development Default"
//                 value={form.name}
//                 onChange={(e) => handleChange("name", e.target.value)}
//               />
//             </div>

//             <div className="col-md-6">
//               <Form.Label>Code {editId ? "(immutable)" : "(optional — derived from name if blank)"}</Form.Label>
//               <Form.Control
//                 placeholder="e.g. DEVELOPMENT_DEFAULT"
//                 value={form.code}
//                 disabled={!!editId}
//                 onChange={(e) => handleChange("code", e.target.value)}
//               />
//             </div>

//             <div className="col-md-12">
//               <Form.Label>Description</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={2}
//                 value={form.description}
//                 onChange={(e) => handleChange("description", e.target.value)}
//               />
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Scope Type</Form.Label>
//               <Form.Select value={form.scope_type} onChange={(e) => handleScopeTypeChange(e.target.value)}>
//                 {SCOPE_TYPES.filter((s) => s !== "TASK").map((s) => <option key={s} value={s}>{s}</option>)}
//               </Form.Select>
//               <Form.Text muted>TASK scope is reserved for a future phase.</Form.Text>
//             </div>

//             {form.scope_type === "TASK_TYPE" && (
//               <div className="col-md-8">
//                 <Form.Label>Task Type</Form.Label>
//                 <Form.Select value={form.scope_id} onChange={(e) => handleChange("scope_id", e.target.value)}>
//                   <option value="">Select task type...</option>
//                   {taskTypes.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
//                 </Form.Select>
//               </div>
//             )}

//             {form.scope_type === "DEPARTMENT" && (
//               <div className="col-md-8">
//                 <Form.Label>Department</Form.Label>
//                 <Form.Select value={form.scope_id} onChange={(e) => handleChange("scope_id", e.target.value)}>
//                   <option value="">Select department...</option>
//                   {departments.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
//                 </Form.Select>
//               </div>
//             )}

//             {form.scope_type === "PROJECT" && (
//               <div className="col-md-8">
//                 <Form.Label>Project</Form.Label>
//                 <Form.Select value={form.scope_id} onChange={(e) => handleChange("scope_id", e.target.value)}>
//                   <option value="">Select project...</option>
//                   {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
//                 </Form.Select>
//               </div>
//             )}

//             {form.scope_type === "PROJECT_MODULE" && (
//               <>
//                 <div className="col-md-4">
//                   <Form.Label>Project</Form.Label>
//                   <Form.Select onChange={(e) => fetchProjectModules(e.target.value)} defaultValue="">
//                     <option value="">Select project first...</option>
//                     {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
//                   </Form.Select>
//                 </div>
//                 <div className="col-md-4">
//                   <Form.Label>Module</Form.Label>
//                   <Form.Select
//                     value={form.scope_id}
//                     onChange={(e) => handleChange("scope_id", e.target.value)}
//                     disabled={loadingScopeTargets}
//                   >
//                     <option value="">Select module...</option>
//                     {projectModules.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
//                   </Form.Select>
//                 </div>
//               </>
//             )}

//             {form.scope_type !== "TASK_TYPE" && (
//               <div className="col-md-6">
//                 <Form.Label>Narrow to Task Type (optional)</Form.Label>
//                 <Form.Select value={form.task_type_id} onChange={(e) => handleChange("task_type_id", e.target.value)}>
//                   <option value="">Applies to all task types in scope</option>
//                   {taskTypes.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
//                 </Form.Select>
//                 <Form.Text muted>
//                   Never changes which scope level applies — only narrows within it.
//                 </Form.Text>
//               </div>
//             )}

//             <div className="col-md-3">
//               <Form.Label>Priority (tie-break)</Form.Label>
//               <Form.Control
//                 type="number"
//                 value={form.priority_order}
//                 onChange={(e) => handleChange("priority_order", e.target.value)}
//               />
//             </div>

//             <div className="col-md-12">
//               <Form.Check
//                 type="checkbox"
//                 label="Set as the active default workflow for this exact scope"
//                 checked={form.is_default}
//                 onChange={(e) => handleChange("is_default", e.target.checked)}
//               />
//               <Form.Text muted>
//                 Only one active default is allowed per (scope type, scope target, task type) combination.
//               </Form.Text>
//             </div>
//           </div>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeModal}>Cancel</Button>
//           <Button className="unit-btn unit-btn-primary" onClick={handleSave} disabled={saving}>
//             {saving ? "Saving..." : editId ? "Update Workflow" : "Create Workflow"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <Modal show={showDeleteModal} onHide={closeDeleteModal} centered className="unit-modal">
//         <Modal.Header closeButton>
//           <Modal.Title>Delete Workflow</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p className="unit-delete-text">
//             Are you sure you want to delete "{deleteTarget?.name}"? This action cannot be undone.
//             If tasks or history reference it, deletion will be blocked — deactivate it instead.
//           </p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>Cancel</Button>
//           <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>Delete</Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import { useNavigate } from "react-router-dom";
import {
  Table,
  Button,
  Form,
  Modal,
  InputGroup,
  Pagination,
  Badge,
  Spinner,
} from "react-bootstrap";
import api from "../../api";
import Can from "../../components/Can";
import { usePermissions } from "../../context/PermissionContext";
import { toast } from "react-toastify";
import "./TaskWorkflowManagementPage.css";

const SCOPE_TYPES = ["GLOBAL", "TASK_TYPE", "DEPARTMENT", "PROJECT", "PROJECT_MODULE", "TASK"];

const initialForm = {
  name: "",
  code: "",
  description: "",
  scope_type: "GLOBAL",
  scope_id: "",
  task_type_id: "",
  priority_order: "",
  is_default: false,
};

export default function TaskWorkflowManagementPage() {
  const navigate = useNavigate();
  const { can } = usePermissions();

  const [workflows, setWorkflows] = useState([]);
  const [total, setTotal] = useState(0);

  const [taskTypes, setTaskTypes] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [projects, setProjects] = useState([]);
  const [projectModules, setProjectModules] = useState([]);
  const [loadingScopeTargets, setLoadingScopeTargets] = useState(false);

  const [search, setSearch] = useState("");
  const [scopeTypeFilter, setScopeTypeFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const [sortField, setSortField] = useState("priority_order");
  const [sortOrder, setSortOrder] = useState("asc");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState(initialForm);
  const [editId, setEditId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [deleteTarget, setDeleteTarget] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    fetchWorkflows();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, scopeTypeFilter, statusFilter, sortField, sortOrder, currentPage, pageSize]);

  useEffect(() => {
    fetchScopeReferenceData();
  }, []);

  const fetchScopeReferenceData = async () => {
    try {
      const [typeRes, deptRes, projectRes] = await Promise.all([
        api.get("/task-types", { params: { is_active: 1, pageSize: 200 } }),
        api.get("/departments", { params: { is_active: 1, pageSize: 200 } }),
        api.get("/projects", { params: { is_active: 1, pageSize: 200 } }),
      ]);
      setTaskTypes(Array.isArray(typeRes.data?.data) ? typeRes.data.data : []);
      setDepartments(Array.isArray(deptRes.data?.data) ? deptRes.data.data : []);
      setProjects(Array.isArray(projectRes.data?.data) ? projectRes.data.data : []);
    } catch (err) {
      console.error("Fetch workflow scope reference data error:", err);
    }
  };

  const fetchProjectModules = async (projectId) => {
    if (!projectId) {
      setProjectModules([]);
      return;
    }
    try {
      setLoadingScopeTargets(true);
      const res = await api.get(`/projects/${projectId}/modules`, { params: { is_active: 1, pageSize: 200 } });
      setProjectModules(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (err) {
      console.error("Fetch project modules error:", err);
      setProjectModules([]);
    } finally {
      setLoadingScopeTargets(false);
    }
  };

  const fetchWorkflows = async () => {
    try {
      setLoading(true);
      const res = await api.get("/task-workflows", {
        params: {
          search: search || undefined,
          scope_type: scopeTypeFilter || undefined,
          is_active: statusFilter === "" ? undefined : statusFilter,
          sortField,
          sortOrder,
          page: currentPage,
          pageSize,
        },
      });
      setWorkflows(Array.isArray(res.data?.data) ? res.data.data : []);
      setTotal(res.data?.meta?.total || 0);
    } catch (err) {
      console.error("Fetch task workflows error:", err);
      toast.error(err.response?.data?.message || "Failed to fetch workflows");
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.max(Math.ceil(total / pageSize), 1);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const sortIcon = (field) => (sortField !== field ? "↕" : sortOrder === "asc" ? "↑" : "↓");

  const handleChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const handleScopeTypeChange = (scopeType) => {
    setForm((prev) => ({ ...prev, scope_type: scopeType, scope_id: "", task_type_id: scopeType === "TASK_TYPE" ? prev.task_type_id : "" }));
    if (scopeType === "PROJECT_MODULE") setProjectModules([]);
  };

  const openAdd = () => {
    setForm(initialForm);
    setEditId(null);
    setShowModal(true);
  };

  const openEdit = (workflow) => {
    setForm({
      name: workflow.name || "",
      code: workflow.code || "",
      description: workflow.description || "",
      scope_type: workflow.scope_type || "GLOBAL",
      scope_id: workflow.scope_id ?? "",
      task_type_id: workflow.task_type_id ?? "",
      priority_order: workflow.priority_order ?? "",
      is_default: !!workflow.is_default,
    });
    setEditId(workflow.id);
    if (workflow.scope_type === "PROJECT_MODULE" && workflow.scope_id) {
      // scope_id for PROJECT_MODULE is a module id — we don't know its parent
      // project here, so the module dropdown is left for the admin to
      // re-select if they want to change it; the current value still displays.
    }
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditId(null);
    setForm(initialForm);
  };

  const handleSave = async () => {
    if (!form.name.trim()) {
      toast.warning("Workflow name is required");
      return;
    }
    if (form.scope_type !== "GLOBAL" && !form.scope_id) {
      toast.warning("Please select a scope target for this scope type");
      return;
    }

    const payload = {
      name: form.name.trim(),
      description: form.description.trim() || null,
      scope_type: form.scope_type,
      scope_id: form.scope_type === "GLOBAL" ? null : Number(form.scope_id),
      task_type_id: form.scope_type === "TASK_TYPE" ? null : (form.task_type_id ? Number(form.task_type_id) : null),
      priority_order: form.priority_order === "" ? 0 : Number(form.priority_order),
      is_default: form.is_default,
    };

    if (!editId) {
      payload.code = form.code.trim() || undefined;
    }

    try {
      setSaving(true);
      if (editId) {
        await api.put(`/task-workflows/${editId}`, payload);
        toast.success("Workflow updated");
      } else {
        await api.post("/task-workflows", payload);
        toast.success("Workflow created");
      }
      closeModal();
      fetchWorkflows();
    } catch (err) {
      console.error("Save workflow error:", err);
      const data = err.response?.data;
      if (data?.code === "WORKFLOW_DEFAULT_CONFLICT") {
        toast.error("An active default workflow already exists for this scope.");
      } else {
        toast.error(data?.message || "Failed to save workflow");
      }
    } finally {
      setSaving(false);
    }
  };

  const toggleStatus = async (workflow) => {
    try {
      await api.patch(`/task-workflows/${workflow.id}/status`, { is_active: !workflow.is_active });
      toast.success(workflow.is_active ? "Workflow deactivated" : "Workflow activated");
      fetchWorkflows();
    } catch (err) {
      console.error("Toggle workflow status error:", err);
      const data = err.response?.data;
      if (data?.code === "WORKFLOW_DEFAULT_CONFLICT") {
        toast.error("An active default workflow already exists for this scope.");
      } else {
        toast.error(data?.message || "Failed to update status");
      }
    }
  };

  const openDeleteModal = (workflow) => {
    setDeleteTarget(workflow);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteTarget(null);
    setShowDeleteModal(false);
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    try {
      await api.delete(`/task-workflows/${deleteTarget.id}`);
      toast.success("Workflow deleted");
      closeDeleteModal();
      fetchWorkflows();
    } catch (err) {
      console.error("Delete workflow error:", err);
      const data = err.response?.data;
      if (data?.code === "WORKFLOW_IN_USE") {
        const d = data.details?.dependents;
        toast.error(`Cannot delete: in use (tasks: ${d?.tasks ?? 0}, history: ${d?.history ?? 0}). Deactivate instead.`);
      } else {
        toast.error(data?.message || "Failed to delete workflow");
      }
      closeDeleteModal();
    }
  };

  const scopeTargetLabel = (workflow) => {
    if (workflow.scope_type === "GLOBAL") return "—";
    if (workflow.scope_type === "TASK_TYPE") return workflow.task_type_name || `#${workflow.scope_id}`;
    return `#${workflow.scope_id}`;
  };

  return (
    <div className="unit-page workflow-mgmt-theme">

      <div className="workflow-heading-box">
        <div className="workflow-heading-content">
          <div className="workflow-heading-icon">
            <i className="fa-solid fa-code-branch" aria-hidden="true"></i>
          </div>

          <div>
            <div className="unit-page-label">Configuration</div>
            <h2>Task Workflow Management</h2>
            <p>Configure which statuses and transitions apply to a task type, department, project or module.</p>
          </div>
        </div>

        <div className="unit-header-actions">
          <Button className="unit-btn unit-btn-light" onClick={fetchWorkflows}>
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>

          <Can moduleKey="task_workflows" actionKey="create">
            <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
              <i className="fa-solid fa-plus" aria-hidden="true"></i>
              Add Workflow
            </Button>
          </Can>
        </div>
      </div>

      <div className="unit-stats-row">
        <div className="unit-stat-card workflow-stat-blue">
          <div className="workflow-stat-content">
            <div className="workflow-stat-text">
              <span>Total Workflows</span>
              <strong>{total}</strong>
            </div>

            <div className="workflow-stat-icon">
              <i className="fa-solid fa-code-branch" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card workflow-stat-purple">
          <div className="workflow-stat-content">
            <div className="workflow-stat-text">
              <span>Current Page</span>
              <strong>{currentPage}</strong>
            </div>

            <div className="workflow-stat-icon">
              <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card workflow-stat-green">
          <div className="workflow-stat-content">
            <div className="workflow-stat-text">
              <span>Rows Per Page</span>
              <strong>{pageSize}</strong>
            </div>

            <div className="workflow-stat-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="unit-card">
        <div className="unit-toolbar workflow-toolbar">
          <div className="workflow-section-title">
            <div className="workflow-section-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>

            <div className="workflow-section-copy">
              <h5>Workflow List</h5>
              <p>Search, filter, add, update, activate/deactivate or delete workflows.</p>
            </div>
          </div>

          <div className="unit-toolbar-actions workflow-filters-row">
            <InputGroup className="unit-search workflow-search">
              <InputGroup.Text aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>
              <Form.Control
                placeholder="Search name or code..."
                aria-label="Search workflow name or code"
                value={search}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearch(e.target.value);
                }}
              />

              {search && (
                <Button
                  className="unit-clear-btn"
                  onClick={() => {
                    setCurrentPage(1);
                    setSearch("");
                  }}
                  title="Clear search"
                  aria-label="Clear search"
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </Button>
              )}
            </InputGroup>

            <div className="workflow-select-wrap">
              <i className="fa-solid fa-crosshairs workflow-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="workflow-filter-select"
                value={scopeTypeFilter}
              onChange={(e) => {
                setCurrentPage(1);
                setScopeTypeFilter(e.target.value);
              }}
            >
              <option value="">All Scope Types</option>
                {SCOPE_TYPES.map((s) => <option key={s} value={s}>{s}</option>)}
              </Form.Select>
            </div>

            <div className="workflow-select-wrap">
              <i className="fa-solid fa-circle-check workflow-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="workflow-filter-select"
                value={statusFilter}
              onChange={(e) => {
                setCurrentPage(1);
                setStatusFilter(e.target.value);
              }}
            >
              <option value="">All Statuses</option>
              <option value="1">Active</option>
                <option value="0">Inactive</option>
              </Form.Select>
            </div>

            <Form.Select
              className="unit-page-size"
              value={pageSize}
              onChange={(e) => {
                setCurrentPage(1);
                setPageSize(Number(e.target.value));
              }}
            >
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
            </Form.Select>
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader">
              <Spinner animation="border" />
              <p>Loading workflows...</p>
            </div>
          ) : (
            <Table responsive className="unit-table">
              <thead>
                <tr>
                  <th className="sortable" onClick={() => handleSort("name")}>Name {sortIcon("name")}</th>
                  <th className="sortable" onClick={() => handleSort("code")}>Code {sortIcon("code")}</th>
                  <th className="sortable" onClick={() => handleSort("scope_type")}>Scope {sortIcon("scope_type")}</th>
                  <th>Target</th>
                  <th>Default</th>
                  <th className="sortable" onClick={() => handleSort("is_active")}>Status {sortIcon("is_active")}</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>

              <tbody>
                {workflows.length > 0 ? (
                  workflows.map((workflow) => (
                    <tr key={workflow.id}>
                      <td data-label="Name">
                        <div className="workflow-name-box">
                          <div className="workflow-letter">
                            {workflow.name?.charAt(0)?.toUpperCase() || "W"}
                          </div>

                          <div className="workflow-name-copy">
                            <strong title={workflow.name}>{workflow.name}</strong>
                            <small>Workflow ID: {workflow.id}</small>
                          </div>
                        </div>
                      </td>
                      <td data-label="Code">
                        <span className="workflow-code-chip">
                          <i className="fa-solid fa-code" aria-hidden="true"></i>
                          {workflow.code || "—"}
                        </span>
                      </td>
                      <td data-label="Scope">
                        <span
                          className={`workflow-scope-chip workflow-scope-${String(
                            workflow.scope_type || ""
                          ).toLowerCase()}`}
                        >
                          <i className="fa-solid fa-crosshairs" aria-hidden="true"></i>
                          {String(workflow.scope_type || "").replace("_", " ")}
                        </span>
                      </td>
                      <td data-label="Target">
                        <span className="workflow-target-chip">
                          <i className="fa-solid fa-bullseye" aria-hidden="true"></i>
                          {scopeTargetLabel(workflow)}
                        </span>
                      </td>
                      <td data-label="Default">
                        {workflow.is_default ? (
                          <Badge className="unit-status workflow-default-badge">
                            <i className="fa-solid fa-star me-1" aria-hidden="true"></i>
                            Default
                          </Badge>
                        ) : (
                          <span className="workflow-muted">Standard</span>
                        )}
                      </td>
                      <td data-label="Status">
                        <Badge
                          className={`unit-status ${
                            workflow.is_active
                              ? "workflow-status-active"
                              : "workflow-status-inactive"
                          }`}
                        >
                          <i
                            className={
                              workflow.is_active
                                ? "fa-solid fa-circle-check me-1"
                                : "fa-solid fa-circle-pause me-1"
                            }
                            aria-hidden="true"
                          ></i>
                          {workflow.is_active ? "Active" : "Inactive"}
                        </Badge>
                      </td>
                      <td data-label="Actions">
                        <div className="unit-actions">
                          <Button
                            className="unit-icon-btn workflow-open-editor"
                            title="Manage statuses & transitions"
                            aria-label="Manage statuses & transitions"
                            onClick={() => navigate(`/admin/task-workflows/${workflow.id}/editor`)}
                          >
                            <i className="fa-solid fa-diagram-project" aria-hidden="true"></i>
                          </Button>

                          <Can moduleKey="task_workflows" actionKey="edit">
                            <Button
                              className="unit-icon-btn unit-edit"
                              title="Edit"
                              aria-label={`Edit ${workflow.name || "workflow"}`}
                              onClick={() => openEdit(workflow)}
                            >
                              <i className="fa-solid fa-pen" aria-hidden="true"></i>
                            </Button>
                          </Can>

                          {(can("task_workflows", "activate") || can("task_workflows", "deactivate")) && (
                            <Button
                              className={`unit-icon-btn workflow-toggle ${
                                workflow.is_active
                                  ? "workflow-toggle-off"
                                  : "workflow-toggle-on"
                              }`}
                              title={workflow.is_active ? "Deactivate" : "Activate"}
                              aria-label={workflow.is_active ? "Deactivate" : "Activate"}
                              onClick={() => toggleStatus(workflow)}
                            >
                              <i className={`fa-solid ${workflow.is_active ? "fa-pause" : "fa-play"}`} aria-hidden="true"></i>
                            </Button>
                          )}

                          <Can moduleKey="task_workflows" actionKey="delete">
                            <Button
                              className="unit-icon-btn unit-delete"
                              title="Delete"
                              aria-label={`Delete ${workflow.name || "workflow"}`}
                              onClick={() => openDeleteModal(workflow)}
                            >
                              <i className="fa-solid fa-trash" aria-hidden="true"></i>
                            </Button>
                          </Can>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-sitemap" aria-hidden="true"></i>
                        </div>
                        <h5>No workflows found</h5>
                        <p>Try another search or add a new workflow.</p>

                        <Can moduleKey="task_workflows" actionKey="create">
                          <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
                            <i className="fa-solid fa-plus" aria-hidden="true"></i>
                            Add Workflow
                          </Button>
                        </Can>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">
            Showing <strong>{workflows.length}</strong> of <strong>{total}</strong> workflows
          </div>

          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
              {compactPageItems([...Array(totalPages)].map((_, i) => (
                <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
                  {i + 1}
                </Pagination.Item>
              )), currentPage)}
              <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
            </Pagination>
          )}
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={closeModal}
        centered
        className="unit-modal"
        size="lg"
        dialogClassName="workflow-admin-modal workflow-admin-modal-lg"
        backdropClassName="workflow-admin-backdrop"
      >
        <Modal.Header closeButton>
          <div className="workflow-modal-heading">
            <div className="workflow-modal-icon">
              <i
                className={
                  editId
                    ? "fa-solid fa-pen-to-square"
                    : "fa-solid fa-code-branch"
                }
                aria-hidden="true"
              ></i>
            </div>

            <div>
              <small>Workflow Setup</small>
              <Modal.Title>{editId ? "Edit Workflow" : "Add New Workflow"}</Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="row g-3">
            <div className="col-md-6">
              <Form.Label>Name</Form.Label>
              <div className="workflow-modal-field">
                <i className="fa-solid fa-code-branch" aria-hidden="true"></i>
                <Form.Control
                  placeholder="e.g. Development Default"
                  value={form.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-6">
              <Form.Label>Code {editId ? "(immutable)" : "(optional — derived from name if blank)"}</Form.Label>
              <div className="workflow-modal-field">
                <i className="fa-solid fa-code" aria-hidden="true"></i>
                <Form.Control
                  placeholder="e.g. DEVELOPMENT_DEFAULT"
                  value={form.code}
                  disabled={!!editId}
                  onChange={(e) => handleChange("code", e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-12">
              <Form.Label>Description</Form.Label>
              <div className="workflow-modal-field workflow-modal-field-textarea">
                <i className="fa-regular fa-note-sticky" aria-hidden="true"></i>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={form.description}
                  onChange={(e) => handleChange("description", e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="workflow-scope-block">
                <Form.Label>Scope Type</Form.Label>
              <Form.Select value={form.scope_type} onChange={(e) => handleScopeTypeChange(e.target.value)}>
                {SCOPE_TYPES.filter((s) => s !== "TASK").map((s) => <option key={s} value={s}>{s}</option>)}
              </Form.Select>
                <Form.Text muted>TASK scope is reserved for a future phase.</Form.Text>
              </div>
            </div>

            {form.scope_type === "TASK_TYPE" && (
              <div className="col-md-8">
                <Form.Label>Task Type</Form.Label>
                <Form.Select value={form.scope_id} onChange={(e) => handleChange("scope_id", e.target.value)}>
                  <option value="">Select task type...</option>
                  {taskTypes.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
                </Form.Select>
              </div>
            )}

            {form.scope_type === "DEPARTMENT" && (
              <div className="col-md-8">
                <Form.Label>Department</Form.Label>
                <Form.Select value={form.scope_id} onChange={(e) => handleChange("scope_id", e.target.value)}>
                  <option value="">Select department...</option>
                  {departments.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
                </Form.Select>
              </div>
            )}

            {form.scope_type === "PROJECT" && (
              <div className="col-md-8">
                <Form.Label>Project</Form.Label>
                <Form.Select value={form.scope_id} onChange={(e) => handleChange("scope_id", e.target.value)}>
                  <option value="">Select project...</option>
                  {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
                </Form.Select>
              </div>
            )}

            {form.scope_type === "PROJECT_MODULE" && (
              <>
                <div className="col-md-4">
                  <Form.Label>Project</Form.Label>
                  <Form.Select onChange={(e) => fetchProjectModules(e.target.value)} defaultValue="">
                    <option value="">Select project first...</option>
                    {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
                  </Form.Select>
                </div>
                <div className="col-md-4">
                  <Form.Label>Module</Form.Label>
                  <Form.Select
                    value={form.scope_id}
                    onChange={(e) => handleChange("scope_id", e.target.value)}
                    disabled={loadingScopeTargets}
                  >
                    <option value="">Select module...</option>
                    {projectModules.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
                  </Form.Select>
                </div>
              </>
            )}

            {form.scope_type !== "TASK_TYPE" && (
              <div className="col-md-6">
                <Form.Label>Narrow to Task Type (optional)</Form.Label>
                <Form.Select value={form.task_type_id} onChange={(e) => handleChange("task_type_id", e.target.value)}>
                  <option value="">Applies to all task types in scope</option>
                  {taskTypes.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
                </Form.Select>
                <Form.Text muted>
                  Never changes which scope level applies — only narrows within it.
                </Form.Text>
              </div>
            )}

            <div className="col-md-3">
              <Form.Label>Priority (tie-break)</Form.Label>
              <Form.Control
                type="number"
                value={form.priority_order}
                onChange={(e) => handleChange("priority_order", e.target.value)}
              />
            </div>

            <div className="col-md-12">
              <Form.Check
                className="workflow-default-check"
                type="checkbox"
                label="Set as the active default workflow for this exact scope"
                checked={form.is_default}
                onChange={(e) => handleChange("is_default", e.target.checked)}
              />
              <Form.Text muted>
                Only one active default is allowed per (scope type, scope target, task type) combination.
              </Form.Text>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button
            className="unit-btn unit-btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner animation="border" size="sm" />
                Saving...
              </>
            ) : (
              <>
                <i className="fa-solid fa-floppy-disk" aria-hidden="true"></i>
                {editId ? "Update Workflow" : "Create Workflow"}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={closeDeleteModal}
        centered
        className="unit-modal"
        dialogClassName="workflow-admin-modal workflow-admin-modal-sm workflow-admin-modal-danger"
        backdropClassName="workflow-admin-backdrop"
      >
        <Modal.Header closeButton>
          <div className="workflow-modal-heading">
            <div className="workflow-modal-icon workflow-modal-icon-danger">
              <i className="fa-solid fa-trash" aria-hidden="true"></i>
            </div>

            <div>
              <small>Delete Action</small>
              <Modal.Title>Delete Workflow</Modal.Title>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="workflow-modal-danger-visual" aria-hidden="true">
            <i className="fa-solid fa-code-branch"></i>
          </div>

          <p className="unit-delete-text text-center">
            Are you sure you want to delete "{deleteTarget?.name}"? This action cannot be undone.
            If tasks or history reference it, deletion will be blocked — deactivate it instead.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>
            <i className="fa-solid fa-trash" aria-hidden="true"></i>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

